import { useMemo } from 'react';

import { LegalEntity } from 'enums';

export const useLegalEntities = () => {
  return useMemo(
    () => [
      {
        label: 'ITR-BEL (ЗАО "Итранзишэн")',
        value: LegalEntity.ItrBEL,
      },
      {
        label: 'ITR-GEO (Itransition Software Georgia)',
        value: LegalEntity.ItrGEO,
      },

      {
        label: 'ITR-LIT ("Itransition" UAB)',
        value: LegalEntity.ItrLIT,
      },
      {
        label: 'ITR-PL (Itransition sp. z o.o.)',
        value: LegalEntity.ItrPL,
      },
      {
        label: 'ITR-UZ ("ITRANSITION" MChJ)',
        value: LegalEntity.ItrUZ,
      },
    ],
    [],
  );
};
